// OneDrive:IgnoreCodeCoverage

export const enum SharingLinkType {
    Network = 1,
    Embed = 3,
    App = 4,
    View = 5,
    Edit = 6,
    Form = 7,
    Direct = 8,
    Organization = 9,
    AppAccess = 10
}